import * as React from 'react';
import { DialogSize } from '../../../../../react-commons/components/data-display/dialog/ResizableDialog';
import { ResourceType } from '../../../resource/enumerations/ResourceType';
import { PersistableInfo } from '../../../resource/resource-base/persistableResourceTypes';
import { DetailedValidationResource } from '../../../resource/resources/validation/detailedValidationResource';
import { getMaximalDialogSizeForResourceTypes } from './getDialogSizeForResourceType';
import { ResizableDialogWithValidation } from './ResizableDialogWithValidation';

export const EditChildBaseDialog= ({
    onClose,
    edited,
    title,
    resourceType,
    children,
    dialogSize,
    resourceValidationResult,
    metaDataInfo,
    versionMetaDataInfo,
    customButtons,
}: {
    onClose: () => void;
    edited: boolean;
    title: string;
    resourceType?: ResourceType | ResourceType[];
    children: React.ReactNode | React.ReactNode[];
    resourceValidationResult?: DetailedValidationResource | DetailedValidationResource[];
    metaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    versionMetaDataInfo?: {
        id: string;
        objectId: string;
        persistableInfo: PersistableInfo;
    } | null;
    customButtons?: React.ReactNode | React.ReactNode[];
    dialogSize?: DialogSize;
}) => {
    return (
        <ResizableDialogWithValidation
            resourceType={resourceType}
            title={title}
            onClose={onClose}
            canClose={!edited}
            dialogSize={dialogSize ?? getMaximalDialogSizeForResourceTypes(resourceType)}
            disableBackdropClick={true}
            resourceValidationResult={resourceValidationResult}
            metaDataInfo={metaDataInfo}
            versionMetaDataInfo={versionMetaDataInfo}
            customButtons={customButtons}
        >
            {children}
        </ResizableDialogWithValidation>
    );
};


